import React, {Component} from "react";

import {Col} from "@amzn/stencil-react-components/layout";
import {Text} from "@amzn/stencil-react-components/text";

export const DETAIL_COL_LABEL_SIZE = "T100";
export const DETAIL_COL_LABEL_COLOR = "neutral70";
export const DETAIL_COL_VALUE_WEIGHT = "medium";

export class GenericDetailColumn extends Component {
  render() {
    return (
      <Col alignItems={this.props.isOnRight ? "flex-end": "flex-start"}>
        <Text fontSize={DETAIL_COL_LABEL_SIZE} color={DETAIL_COL_LABEL_COLOR}>
          {this.props.label}
        </Text>
        <Text fontWeight={DETAIL_COL_VALUE_WEIGHT}>
          {this.props.value}
        </Text>
      </Col>
    );
  }
}
